export const Dimensions = {
    screen : {
        width : 0,
        height : 0
    }
}